import { z } from "zod";
import { apiEnvelope } from "@/shared/api/api-contract";
import {
  AI_CAPABILITIES,
  AI_INPUT_FIELDS,
  AI_PARAMETER_TYPES,
} from "@/shared/model/ai-enums";
import {
  MODEL_PRESENTATION_BADGES,
  MODEL_PRESENTATION_POSITIONINGS,
  MODEL_PRESENTATION_STRENGTHS,
} from "../model/model-presentation";

const parameterRuleSchema = z.object({
  type: z.enum(AI_PARAMETER_TYPES).optional(),
  description: z.string().nullish(),
  enum: z.array(z.unknown()).nullish(),
  minimum: z.number().nullish(),
  maximum: z.number().nullish(),
  minLength: z.number().int().nullish(),
  maxLength: z.number().int().nullish(),
  minItems: z.number().int().nullish(),
  maxItems: z.number().int().nullish(),
});

const capabilitySchema = z.object({
  capability: z.enum(AI_CAPABILITIES),
  presentation: z
    .object({
      badge: z.enum(MODEL_PRESENTATION_BADGES).nullish(),
      positioning: z.enum(MODEL_PRESENTATION_POSITIONINGS).nullish(),
      strengths: z
        .array(z.enum(MODEL_PRESENTATION_STRENGTHS))
        .refine(
          (values) => new Set(values).size === values.length,
          "presentation.strengths 不允许重复",
        )
        .default([]),
      shortDescription: z.string().max(255).nullish(),
      sortOrder: z.number().int().nonnegative().default(0),
    })
    .nullish(),
  parameterSchema: z
    .object({
      required: z.array(z.enum(AI_INPUT_FIELDS)).default([]),
      properties: z.record(z.string(), parameterRuleSchema).default({}),
      additionalProperties: z.boolean().nullish(),
    })
    .nullish(),
});

export const modelCatalogResponseSchema = apiEnvelope(
  z.array(
    z.object({
      id: z.number().int(),
      name: z.string().min(1),
      description: z.string().nullish(),
      capabilities: z.array(capabilitySchema).default([]),
    }),
  ),
);

export type ModelCatalogResponse = z.infer<typeof modelCatalogResponseSchema>;
